// ADD ALL IMAGES IN WEBPACK FILE_LOADER TODO
// eslint-disable-next-line
requireAll(require.context('../images/', true, /\.(jpg|png|ico)$/))

export default window.brandProps.style

function requireAll(r) {
  r.keys().forEach(r)
}
